import React, {Fragment, useEffect, useState} from 'react'
import {connect} from 'react-redux';
import {getCustomers} from "./actions";
import _ from 'lodash' ;
import withPaging from '../common/withPaging';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';

const Customers = (props) => {

    const {customers, customersPaging, pageNumber} = props;
    const {eventId} = useParams();

    const [customerType, setCustomerType] = useState(0);

    useEffect(() => {
        getList(pageNumber);
    }, [pageNumber]);

    const getList = (page) => {
        let query = {
            pageNumber: page,
            pageSize: 10,
            customerType
        };
        if (eventId) {
            query = {...query,
                eventId: Number(eventId)
            }
        }
        props.getCustomers(query);
    };

    useEffect(() => {
        props.setPageNumber(1);
        if (pageNumber == 1) {
            getList(1);
        }
    }, [customerType])


    return (
        <Fragment>
            {!eventId ?
            <div className="maximumSizeHandler">
                <div className="contentTitle">
                    <span className=" font-size_24 boldFont middleContext">لیست مشتریان</span>
                </div>
            </div>: null}
            <span className="lineSeparator"></span>
            <div className="maximumSizeHandler">
                <div className="tableActions">
                    <div className="filters">
                        <span className="icon icon-filter"></span>
                        <div onClick={e => setCustomerType(0)} className={classNames("filterItem realUser blockInline clickShape", {"active": customerType == 0})}>
                            <span className="icon icon-user"></span> حقیقی
                        </div>
                        <div onClick={e => setCustomerType(1)} className={classNames("filterItem legalUser blockInline clickShape", {"active": customerType == 1})}>
                            <span className="icon icon-building"></span> حقوقی
                        </div>
                    </div>
                </div>

                <div className="tableStructure">
                    <table>
                        <tr className="font-size_16 mediumWFont">
                            {!eventId ? <th>نام نمایشگاه</th> : null}
                            <th>نام مشتری</th>
                            <th>ایمیل</th>
                            <th>شماره همراه</th>
                            <th>تعداد کتاب‌های خریده شده</th>
                            {customerType == 1 ?
                                <Fragment>
                                    <th>کد اقتصادی</th>
                                    <th>شناسه ملی</th>
                                    <th>شماره ثبت</th>
                                </Fragment> : null}
                            <th>تاریخ آخرین خرید</th>
                            <th/>
                        </tr>
                        {!_.isEmpty(customersPaging) && customersPaging[pageNumber] ? _.map(customersPaging[pageNumber], id => {
                            return (
                                <Fragment>
                                    <tr className="font-size_14">
                                        {!eventId ? <td>{customers[id].event}</td> : null}
                                        <td>{customers[id].fullName}</td>
                                        <td>{customers[id].email}</td>
                                        <td>{customers[id].phoneNumber}</td>
                                        <td>{customers[id].ordersCount}</td>
                                        {customerType == 1 ?
                                            <Fragment>
                                                <td>{customers[id].financialCode}</td>
                                                <td>{customers[id].nationalCode}</td>
                                                <td>{customers[id].registrationId}</td>
                                            </Fragment> : null}
                                        <td>{`${customers[id].jalaliDate} ${customers[id].jalaliTime}`}</td>

                                        <td><span className="icon icon-eraser" /></td>

                                    </tr>

                                    {/*<td className="blueColor">مشاهده نتایج <span className="icon icon-left font-size_12"></span></td>*/}
                                </Fragment>
                            )
                        }) : null}

                    </table>
                </div>
                {!_.isEmpty(customers) ? props.paginationRender(pageNumber, Math.ceil(customers[customersPaging[1][0]].totalCount / 10)) : null}
            </div>
        </Fragment>
    );
};

const mapStateToProps = ({customers, customersPaging, customerInfos}) => ({
    customers,
    customersPaging,
    customerInfos
});

export default connect(mapStateToProps, {getCustomers})(withPaging(Customers));
